import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from 'src/app/services/admin.service';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'app-add-file',
  templateUrl: './add-file.component.html',
  styleUrls: ['./add-file.component.scss']
})
export class AddFileComponent implements OnInit {
  fileForm!: FormGroup;
  folderId: number = 0;
  fileToUpload!: File;
  loader: boolean = false;
  isTablet: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddFileComponent>,
    private adminservice: AdminService,
    private activeroute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit() {

    this.activeroute.queryParams.subscribe(params => {
      this.folderId = +params['id'];
    });

    this.formBuilder();
    if (this.data?.id > 0) {
      const data = {
        folderId: this.data.id,
        name: this.data.nombre
      }
      this.fileForm.patchValue(data);
    }
    
    this.isTablet = this.router.url.includes('pastillas') ? true : false;
  }

  formBuilder(){
    this.fileForm = new FormGroup({
      folderId: new FormControl(0),
      typeFile: new FormControl(0),
      name: new FormControl('', Validators.required),
      link: new FormControl(''),
      file: new FormControl('')
    });
  }

  saveFileFolder(){
    if (!this.fileForm.valid) {
      return
    }

    const request = {
      directorio_id: this.folderId,
      tipo_contenido: this.data,
      nombre: this.fileForm.value.name,
      enlace: this.fileForm.value.link,
    }
    this.loader = true;
    
    if (this.isTablet) {
      this.adminservice.saveFileTablet(request, this.fileToUpload).subscribe(
        (response)=>{
          this.loader = false;
          if (response.rtn) {
            this.dialogRef.close(true)
          }
        }
      );
    }else{
      this.adminservice.saveFileFolder(request, this.fileToUpload).subscribe(
        (response)=>{
          this.loader = false;
          if (response.rtn) {
            this.dialogRef.close(true)
          }
        }
      );
    }

  }

  changeFile(event:any): void{
    this.fileToUpload = event.target.files.item(0);
    const validation = this.fileToUpload.name.split('.')
    if (validation.length > 2) {
      this.dialogRef.close();
      this.dialog.open(AlertComponent,{
        width: '776px',
        disableClose: true,
        data: {
          type: 'alert',
          title: 'Ocurrió un error',
          description: `El nombre del archivo no puede contener puntos. Cambie el nombre e inténtelo denuevo`,
          textButton: 'Entendido'
        }
      });
    } else {
      // @ts-ignore
      this.fileForm.controls.file.setValue(this.fileToUpload.name);
    }
    
  }

}
